__webpack_require__.p = "https://assets-ab.periodica.press/7689dcb-26837150556/";